import l from "react";
import { Text as d } from "../../../Text/Text.js";
import { cls as r } from "../../../../helpers/cls.js";
const t = _ref => {
  let {
    children: e,
    mode: o,
    fixedHeightElements: a
  } = _ref;
  return !e && a ? l.createElement("span", {
    className: "olx-ad-card__old-price--fixed"
  }) : e ? l.createElement(d.Caption, {
    tag: "p",
    className: r("olx-ad-card__old-price", "olx-ad-card__old-price--".concat(o))
  }, e) : null;
};
export { t as OldPrice };